import { render, staticRenderFns } from "./CustomerUpdatesEdit.vue?vue&type=template&id=e27c416a"
import script from "./CustomerUpdatesEdit.vue?vue&type=script&lang=js"
export * from "./CustomerUpdatesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports